"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobsQueryDtoSchema = exports.ApplicationResult = exports.ATS_POSITION_TO_FR_MATCH_VARIANTS = exports.ATS_POSITION_TO_FR_LABEL = exports.CIBLI_CONTRACT_TYPE_MAP = exports.SALARY_PERIODICITY_MAP = exports.SALARY_PERIODICITIES = exports.EMPLOYMENT_TYPES = exports.CONTRACT_TYPES = exports.ATS_POSITION_VALUES = exports.MatchSource = exports.MatchLevel = exports.BOOTH_NO_JOB_SOURCES = exports.NO_BOOTH_JOB_SOURCES = exports.ACTIVE_BOOTH_JOB_SOURCES = exports.JobSource = void 0;
exports.getBoothJobSources = getBoothJobSources;
exports.normalizeSalaryPeriodicity = normalizeSalaryPeriodicity;
exports.normalizeContractTypeForMatch = normalizeContractTypeForMatch;
exports.contractTypeMatchesFilter = contractTypeMatchesFilter;
const zod_1 = __importDefault(require("zod"));
var JobSource;
(function (JobSource) {
    JobSource["CIBLI"] = "Cibli";
    JobSource["FRANCE_TRAVAIL"] = "FranceTravail";
    // Retained for legacy data and code paths, but not enabled for booth sources.
    JobSource["CIBLI_LEGACY"] = "CibliLegacy";
})(JobSource || (exports.JobSource = JobSource = {}));
exports.ACTIVE_BOOTH_JOB_SOURCES = [JobSource.CIBLI, JobSource.FRANCE_TRAVAIL];
exports.NO_BOOTH_JOB_SOURCES = '__NONE__';
exports.BOOTH_NO_JOB_SOURCES = exports.NO_BOOTH_JOB_SOURCES;
function getBoothJobSources(configuredSources) {
    if (!(configuredSources === null || configuredSources === void 0 ? void 0 : configuredSources.length))
        return [...exports.ACTIVE_BOOTH_JOB_SOURCES];
    if (configuredSources.includes(exports.NO_BOOTH_JOB_SOURCES))
        return [];
    return exports.ACTIVE_BOOTH_JOB_SOURCES.filter(source => configuredSources.includes(source));
}
var MatchLevel;
(function (MatchLevel) {
    MatchLevel["STRONG"] = "strong";
    MatchLevel["MODERATE"] = "moderate";
    MatchLevel["FALLBACK"] = "fallback";
})(MatchLevel || (exports.MatchLevel = MatchLevel = {}));
var MatchSource;
(function (MatchSource) {
    MatchSource["DISTANCE"] = "distance";
    MatchSource["SEMANTIC"] = "semantic";
})(MatchSource || (exports.MatchSource = MatchSource = {}));
// WARNING: Several fields (contractType, employmentTypes, salary, experience) are not yet standardized by the ATS; expect changes when ATS normalization lands.
// The jobs type will be updated when ATS normalization lands.
// --- Contract types: union of ATS v2 position enum + free strings (FT / legacy) ---
/** ATS v2 position enum values (codegen). Used as canonical filter values in UI. */
exports.ATS_POSITION_VALUES = [
    'PERMANENT',
    'FIXED_TERM',
    'TEMPORARY',
    'INTERNSHIP',
    'WORK_STUDY',
    'FREELANCE',
    'FRANCHISE',
    'TRAINING_PROGRAM',
];
/** Legacy contract type values (v1/FT normalized). Kept for backward compat and FT/v1 matching. */
exports.CONTRACT_TYPES = {
    CDI: 'cdi',
    CDD: 'cdd',
    INTERIM: 'interim',
    TEMPORARY: 'temporary',
    TELEWORKING: 'teleworking',
    PARTIAL: 'partial',
};
// Standard employment type values
exports.EMPLOYMENT_TYPES = {
    FULL_TIME: 'full-time',
    PART_TIME: 'part-time',
};
// Salary periodicity standard values
exports.SALARY_PERIODICITIES = {
    ANNUAL: 'annual',
    MONTHLY: 'monthly',
    HOURLY: 'hourly',
    DAILY: 'daily',
};
// Map from various API/user inputs to standard periodicity
exports.SALARY_PERIODICITY_MAP = {
    // Annual variants
    annuel: exports.SALARY_PERIODICITIES.ANNUAL,
    annual: exports.SALARY_PERIODICITIES.ANNUAL,
    yearly: exports.SALARY_PERIODICITIES.ANNUAL,
    'par an': exports.SALARY_PERIODICITIES.ANNUAL,
    '/an': exports.SALARY_PERIODICITIES.ANNUAL,
    an: exports.SALARY_PERIODICITIES.ANNUAL,
    year: exports.SALARY_PERIODICITIES.ANNUAL,
    // Monthly variants
    mensuel: exports.SALARY_PERIODICITIES.MONTHLY,
    monthly: exports.SALARY_PERIODICITIES.MONTHLY,
    mois: exports.SALARY_PERIODICITIES.MONTHLY,
    'par mois': exports.SALARY_PERIODICITIES.MONTHLY,
    '/mois': exports.SALARY_PERIODICITIES.MONTHLY,
    '/mo': exports.SALARY_PERIODICITIES.MONTHLY,
    month: exports.SALARY_PERIODICITIES.MONTHLY,
    // Hourly variants
    horaire: exports.SALARY_PERIODICITIES.HOURLY,
    hourly: exports.SALARY_PERIODICITIES.HOURLY,
    heure: exports.SALARY_PERIODICITIES.HOURLY,
    '/h': exports.SALARY_PERIODICITIES.HOURLY,
    hour: exports.SALARY_PERIODICITIES.HOURLY,
    // Daily variants
    journalier: exports.SALARY_PERIODICITIES.DAILY,
    daily: exports.SALARY_PERIODICITIES.DAILY,
    jour: exports.SALARY_PERIODICITIES.DAILY,
    '/jour': exports.SALARY_PERIODICITIES.DAILY,
    day: exports.SALARY_PERIODICITIES.DAILY,
};
/**
 * Normalize salary periodicity from various formats to standard value
 * @param periodicity Raw periodicity string from API
 * @returns Normalized periodicity or null if unknown
 */
function normalizeSalaryPeriodicity(periodicity) {
    if (!periodicity)
        return null;
    const normalized = periodicity.toLowerCase().trim();
    return exports.SALARY_PERIODICITY_MAP[normalized] || null;
}
// Map from Cibli API values to standard values
exports.CIBLI_CONTRACT_TYPE_MAP = {
    cdi: exports.CONTRACT_TYPES.CDI,
    CDI: exports.CONTRACT_TYPES.CDI,
    Cdi: exports.CONTRACT_TYPES.CDI,
    cdd: exports.CONTRACT_TYPES.CDD,
    CDD: exports.CONTRACT_TYPES.CDD,
    Cdd: exports.CONTRACT_TYPES.CDD,
    interim: exports.CONTRACT_TYPES.INTERIM,
    INTERIM: exports.CONTRACT_TYPES.INTERIM,
    Intérim: exports.CONTRACT_TYPES.INTERIM,
    intérim: exports.CONTRACT_TYPES.INTERIM,
    temporary: exports.CONTRACT_TYPES.TEMPORARY,
    Temporary: exports.CONTRACT_TYPES.TEMPORARY,
    TEMPORARY: exports.CONTRACT_TYPES.TEMPORARY,
    teleworking: exports.CONTRACT_TYPES.TELEWORKING,
    Teleworking: exports.CONTRACT_TYPES.TELEWORKING,
    TELEWORKING: exports.CONTRACT_TYPES.TELEWORKING,
    télétravail: exports.CONTRACT_TYPES.TELEWORKING,
    Télétravail: exports.CONTRACT_TYPES.TELEWORKING,
    partial: exports.CONTRACT_TYPES.PARTIAL,
    Partial: exports.CONTRACT_TYPES.PARTIAL,
    PARTIAL: exports.CONTRACT_TYPES.PARTIAL,
    'temps-partiel': exports.CONTRACT_TYPES.PARTIAL,
    'Temps-partiel': exports.CONTRACT_TYPES.PARTIAL,
};
/**
 * ATS position → French label (display in UI).
 * PERMANENT → "CDI", FIXED_TERM → "CDD", etc.
 */
exports.ATS_POSITION_TO_FR_LABEL = {
    PERMANENT: 'CDI',
    FIXED_TERM: 'CDD',
    TEMPORARY: 'Intérim',
    INTERNSHIP: 'Stage',
    WORK_STUDY: 'Alternance',
    FREELANCE: 'Freelance',
    FRANCHISE: 'Franchise',
    TRAINING_PROGRAM: 'Formation',
};
/**
 * ATS position → normalized French variants (lowercase, no accents) for matching v1/FT.
 * When user selects e.g. PERMANENT ("CDI"), we match job.contractType against these strings.
 */
/** All values must be normalized (lowercase, no accents) for matching. */
exports.ATS_POSITION_TO_FR_MATCH_VARIANTS = {
    PERMANENT: ['cdi', 'permanent', 'contrat a duree indeterminee', 'duree indeterminee'],
    FIXED_TERM: ['cdd', 'contrat a duree determinee', 'duree determinee', 'fixed', 'term'],
    TEMPORARY: ['interim', 'temporary', 'mis', 'mission', 'contrat de mission'],
    INTERNSHIP: ['stage', 'internship', 'alternance'],
    WORK_STUDY: ['alternance', 'apprentissage', 'contrat de professionnalisation', 'work_study'],
    FREELANCE: ['freelance', 'independent', 'independant', 'portage'],
    FRANCHISE: ['franchise'],
    TRAINING_PROGRAM: ['formation', 'programme', 'training', 'contrat de formation'],
};
/**
 * Normalize string for contract-type matching: lowercase, trim, remove accents.
 */
function normalizeContractTypeForMatch(value) {
    if (!value || typeof value !== 'string')
        return '';
    return value
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '');
}
/**
 * Returns true if job's contractType matches any of the selected filters.
 * - If filters include 'ALL' or filters are empty: matches.
 * - For CIBLI (v2): exact match (job.contractType is ATS position).
 * - For FRANCE_TRAVAIL / CIBLI_LEGACY: match using French variants (ATS_POSITION_TO_FR_MATCH_VARIANTS).
 */
function contractTypeMatchesFilter(jobContractType, jobSource, selectedFilters) {
    var _a;
    if (!selectedFilters.length || selectedFilters.includes('ALL'))
        return true;
    if (!jobContractType || !jobContractType.trim())
        return false;
    const normalized = normalizeContractTypeForMatch(jobContractType);
    for (const filter of selectedFilters) {
        if (filter === 'ALL')
            return true;
        // v2: exact match (we store position as-is for Cibli)
        if (jobSource === JobSource.CIBLI) {
            if (jobContractType === filter)
                return true;
            continue;
        }
        // v1 / FT: match against French variants (normalized)
        const variants = (_a = exports.ATS_POSITION_TO_FR_MATCH_VARIANTS[filter]) !== null && _a !== void 0 ? _a : [];
        if (variants.some(v => normalized.includes(v) || v.includes(normalized)))
            return true;
    }
    return false;
}
/**
 * Résultat d'une candidature à une offre d'emploi
 * Permet d'adapter l'UI selon le type de candidature effectuée
 */
var ApplicationResult;
(function (ApplicationResult) {
    /** Candidature envoyée directement (Cibli ATS) */
    ApplicationResult["APPLIED"] = "APPLIED";
    /** Informations de contact envoyées par SMS (France Travail) */
    ApplicationResult["INFO_SENT_SMS"] = "INFO_SENT_SMS";
    ApplicationResult["INFO_SENT_EMAIL"] = "INFO_SENT_EMAIL";
})(ApplicationResult || (exports.ApplicationResult = ApplicationResult = {}));
// TODO: Merge JobsQuery and JobSearchParams into a single type :/
exports.jobsQueryDtoSchema = zod_1.default.object({
    page: zod_1.default.coerce.number().int().positive().default(1).optional(),
    limit: zod_1.default.coerce.number().int().positive().max(100).default(10).optional(),
    search: zod_1.default.string().optional(),
    city: zod_1.default.string().optional(),
    contractTypes: zod_1.default.array(zod_1.default.string()).optional(),
    employmentTypes: zod_1.default.array(zod_1.default.string()).optional(),
    onlyWithJobCard: zod_1.default.boolean().optional(), // Internal flag, not exposed to frontend
    boothId: zod_1.default.string().optional(), // ID de la cabine pour appliquer les exclusions
});
